import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "label"]

  connect() {
    const stored = localStorage.getItem("sidebarExpanded")
    this.expanded = stored === null ? true : stored === "true"

    // Suppress transition on initial load to prevent layout jump
    const sidebar = this.sidebarTarget
    sidebar.style.transition = "none"
    this._apply()
    // Force a reflow then restore the CSS transition
    sidebar.offsetHeight // eslint-disable-line no-unused-expressions
    sidebar.style.transition = ""

    // Remove the early-paint helper class now that Stimulus owns the state
    document.documentElement.classList.remove("sb-collapsed")
  }

  toggle() {
    this.expanded = !this.expanded
    localStorage.setItem("sidebarExpanded", this.expanded)
    this._apply()
  }

  _apply() {
    const sidebar = this.sidebarTarget
    if (this.expanded) {
      sidebar.classList.add("sidebar--expanded")
      sidebar.classList.remove("sidebar--collapsed")
    } else {
      sidebar.classList.add("sidebar--collapsed")
      sidebar.classList.remove("sidebar--expanded")
    }
  }
}
